// extracted by mini-css-extract-plugin
export default {"isFloating":"SaveDiscard_isFloating__RjBAT"};